import React from 'react';

interface WizardProgressIndicatorProps {
  currentStep: number;
  steps: string[];
}

const WizardProgressIndicator: React.FC<WizardProgressIndicatorProps> = ({
  currentStep,
  steps,
}) => {
  return (
    <div className="w-full max-w-4xl mx-auto px-4 sm:px-8 py-4 sm:py-6">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;

          return (
            <div key={stepNumber} className="flex items-center flex-1">
              <div className="flex flex-col items-center">
                <div
                  className={`
                    w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center
                    font-['Ovo',_serif] text-[14px] sm:text-[16px] font-medium transition-colors
                    ${
                      isActive
                        ? 'bg-[#c6a664] text-white'
                        : isCompleted
                          ? 'bg-[#1f1f1f] text-white'
                          : 'bg-[#eaeaea] text-[#767472]'
                    }
                  `}
                >
                  {isCompleted ? '✓' : stepNumber}
                </div>
                <span
                  className={`
                    mt-1 sm:mt-2 text-[11px] sm:text-[14px] font-['Ovo',_serif] text-center
                    hidden sm:block
                    ${isActive ? 'text-[#1f1f1f]' : 'text-[#767472]'}
                  `}
                >
                  {step}
                </span>
              </div>

              {index < steps.length - 1 && (
                <div className="flex-1 mx-2 sm:mx-4 h-[2px] bg-[#eaeaea] relative top-0 sm:top-[-12px]">
                  <div
                    className={`
                      h-full transition-all duration-300
                      ${isCompleted ? 'bg-[#1f1f1f] w-full' : 'w-0'}
                    `}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WizardProgressIndicator;
